import {
  TreemapModule,
  createTreemapServices
} from "./chunk-XRWGC2XP.mjs";
import "./chunk-4KMFLZZN.mjs";
export {
  TreemapModule,
  createTreemapServices
};
